export const MAX_VALUE_IN_MONTH = 720;
